import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  choose(event) {
    event.preventDefault()

    const form = event.currentTarget.closest("form")
    if (!form) return

    form.submit()
  }
}
